import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1300px;
  display: flex;
  flex-direction: column;
  padding-bottom: 40px;

  h1 {
    text-align: left;
    margin-bottom: 30px;
    color: #1a1a1a;
    font-size: 24px;
  }

  .profile-content {
    display: grid;
    grid-template-columns: 350px 1fr;
    gap: 30px;
    @media (max-width: 900px) {
      grid-template-columns: 1fr;
    }
  }

  .photo-card {
    background: #fff;
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    .photo-container {
      position: relative;
      img {
        width: 180px;
        height: 180px;
        border-radius: 50%;
        object-fit: cover;
        border: 4px solid #008037; /* Padrão do Header */
        padding: 3px;
        background: #fff;
      }
    }

    h3 {
      margin: 0;
      font-size: 20px;
      color: #333;
    }
    p {
      margin: 0;
      color: #888;
      font-size: 14px;
      text-transform: capitalize;
    }
  }

  .info-card {
    background: #fff;
    border-radius: 20px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;

    .section-title {
      font-size: 16px;
      font-weight: 600;
      color: #008037;
      margin-bottom: 25px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 10px;
      &::after {
        content: "";
        flex: 1;
        height: 1px;
        background: #f0f0f0;
      }
    }

    .info-grid {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 25px;
      @media (max-width: 600px) {
        grid-template-columns: 1fr;
      }

      .info-item {
        display: flex;
        flex-direction: column;
        gap: 5px;
        label {
          font-size: 12px;
          color: #999;
          font-weight: 500;
          text-transform: uppercase;
        }
        span {
          font-size: 15px;
          color: #333;
          font-weight: 600;
        }
      }
    }

    .actions {
      margin-top: 40px;
      display: flex;
      gap: 15px;

      button {
        padding: 10px 25px;
        border-radius: 50px;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .edit-btn {
        background: #008037;
        color: white;
        border: none;
        &:hover {
          opacity: 0.9;
        }
      }

      .logout-btn {
        background: #fff;
        color: #f44336;
        border: 1px solid #f44336;
        &:hover {
          background: #fff5f5;
        }
      }
    }
  }
`;
